var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-container" }, [
    _c(
      "ul",
      { ref: "chat-messages", staticClass: "messages mb-5" },
      [
        _vm._l(_vm.messages, function(message) {
          return _c(
            "li",
            {
              key: message.response_id,
              staticClass: "message",
              class: message.role
            },
            [
              message.role === "assistant"
                ? _c(
                    "div",
                    { staticClass: "message-item-wrapper" },
                    [
                      _c("InlineSvg", {
                        staticClass: "image",
                        attrs: { src: "/images/icons/ic-stanley-profile.svg" }
                      }),
                      _vm._v(" "),
                      _vm.hasChatAiV2Experiment
                        ? _c("div", {
                            staticClass: "para-2",
                            domProps: {
                              innerHTML: _vm._s(_vm.textToShow(message))
                            }
                          })
                        : _c("span", {
                            staticClass: "para-2",
                            domProps: {
                              innerHTML: _vm._s(_vm.textToShow(message))
                            }
                          })
                    ],
                    1
                  )
                : _c("div", { staticClass: "message-item-wrapper" }, [
                    _c("img", {
                      staticClass: "image",
                      attrs: { src: _vm.user.profile_image }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "para-2" }, [
                      _vm._v(_vm._s(message.content))
                    ])
                  ]),
              _vm._v(" "),
              message.role === "assistant" && message.response_id !== "def"
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-row justify-content-between" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "feedback-wrapper",
                          class: {
                            "has-feedback":
                              message.feedback_status === -1 ||
                              message.feedback_status === 1
                          }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "feedback-button",
                              class: {
                                selected: message.feedback_status === 1
                              },
                              on: {
                                click: function($event) {
                                  return _vm.sendMessageFeedback(message, 1)
                                }
                              }
                            },
                            [
                              _c("InlineSvg", {
                                staticClass: "no-feedback",
                                attrs: {
                                  src: "/images/icons/ic-thumbs-up-outline.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("InlineSvg", {
                                staticClass: "chosen",
                                attrs: {
                                  src: "/images/icons/ic-thumbs-up-solid.svg"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "feedback-button",
                              class: {
                                selected: message.feedback_status === -1
                              },
                              on: {
                                click: function($event) {
                                  return _vm.sendMessageFeedback(message, -1)
                                }
                              }
                            },
                            [
                              _c("InlineSvg", {
                                staticClass: "no-feedback",
                                attrs: {
                                  src:
                                    "/images/icons/ic-thumbs-down-outline.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("InlineSvg", {
                                staticClass: "chosen",
                                attrs: {
                                  src: "/images/icons/ic-thumbs-down-solid.svg"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "copy-button",
                          on: {
                            click: function($event) {
                              _vm.copyMessageContent(_vm.textToShow(message))
                            }
                          }
                        },
                        [
                          _c("InlineSvg", {
                            staticClass: "no-feedback",
                            attrs: { src: "/images/icons/ic-copy.svg" }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        }),
        _vm._v(" "),
        _vm.formSubmitting
          ? _c(
              "li",
              {
                staticClass:
                  "py-5 d-flex justify-content-center align-items-center flex-column",
                attrs: { id: "message-loading" }
              },
              [
                _c("h3", { staticClass: "text-bold mb-4" }, [
                  _vm._v("Stanley is thinking...")
                ]),
                _vm._v(" "),
                _c("AppProgress", {
                  staticClass: "stanley-loading-bar",
                  attrs: { value: _vm.progressBarValue }
                })
              ],
              1
            )
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.messages.length == 1
      ? _c("div", { staticClass: "example-questions" }, [
          _c(
            "h3",
            {
              staticClass:
                "d-md-flex d-none text-bold text-center align-items-center justify-content-center gap mb-5"
            },
            [
              _c("InlineSvg", {
                attrs: { src: "/images/icons/ic-lightning.svg" }
              }),
              _vm._v("Example Questions\n\t\t")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "h4",
            {
              staticClass:
                "d-md-none text-bold text-center d-flex align-items-center justify-content-center mb-4"
            },
            [
              _c("InlineSvg", {
                attrs: { src: "/images/icons/ic-lightning.svg" }
              }),
              _vm._v("Example Questions\n\t\t")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "question-chooser mb-4 mb-md-5" },
            _vm._l(_vm.exampleQuestions, function(question, index) {
              return _c(
                "button",
                {
                  key: index,
                  staticClass: "question-choice",
                  on: {
                    click: function($event) {
                      return _vm.initiateQuestion(question)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "para-3 text-bold" }, [
                    _vm._v(_vm._s(question))
                  ]),
                  _vm._v(" "),
                  _c("InlineSvg", {
                    staticClass: "question-arrow-image",
                    attrs: { src: "/images/icons/ic-arrow-right.svg" }
                  })
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.showHelpSection
            ? _c(
                "div",
                {
                  staticClass:
                    "alpha-note para-3 mb-4 mb-md-5 d-flex flex-column gap-8px"
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n\t\t\t\tNeed more information about the platform? Visit our\n\t\t\t\t"
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "mailto",
                        on: {
                          click: function($event) {
                            return _vm.clickMoreInformationLink(
                              "https://help.stan.store/"
                            )
                          }
                        }
                      },
                      [_vm._v("Help Center")]
                    ),
                    _vm._v(" or email\n\t\t\t\t"),
                    _c(
                      "a",
                      { staticClass: "mailto", on: { click: _vm.openBeacon } },
                      [_vm._v("support")]
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "question-form",
        attrs: { id: "question-form", method: "post" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.handleSubmit.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "question-input-wrapper d-flex justify-content-center align-items-center",
            class: { disabled: _vm.formSubmitting }
          },
          [
            _c("AppInput", {
              staticClass: "col px-1",
              attrs: {
                placeholder: "Type some text here...",
                disabled: _vm.formSubmitting
              },
              model: {
                value: _vm.inputQuestion,
                callback: function($$v) {
                  _vm.inputQuestion = $$v
                },
                expression: "inputQuestion"
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-transparent col-auto",
                attrs: { type: "submit", disabled: _vm.formSubmitting }
              },
              [
                _c("InlineSvg", { attrs: { src: "/images/icons/ic-send.svg" } })
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }